var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loginform"},[_c('div',{staticClass:"login"},[_vm._m(0),_c('div',{staticClass:"title",class:{ 'text-danger': _vm.textDanger }},[_vm._v("\n      "+_vm._s(_vm.loginMsg)+"\n    ")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require("@/assets/images/logo.svg")}})])
}]

export { render, staticRenderFns }